import { format, isValid } from 'date-fns';

import {
  TierName,
  TierStatusName,
  useSweetpassInfoForAccountDeletionQuery,
} from '@order/graphql';
import { useFeatureFlag } from '@order/LaunchDarkly';

export const useSweetpassAccountDeletionData = () => {
  const isSweetpassEnabled = useFeatureFlag('OPS-sweetpass-enabled', {
    listenForChanges: true,
  });

  const [response] = useSweetpassInfoForAccountDeletionQuery({
    pause: !isSweetpassEnabled,
    requestPolicy: 'network-only',
  });

  const isFetchingSweetpassData = response?.fetching;

  // ─── Subscriptions ───────────────────────────────────────────────────

  const subscriptions = response?.data?.getSubscriptions;
  const subscription =
    subscriptions && subscriptions.length > 0 ? subscriptions[0] : undefined;
  const nextBillingDate = subscription?.nextBillingDate ?? '';
  const subscriptionId = subscription?.id ?? '';

  // ─── Tier ────────────────────────────────────────────────────────────

  const loyaltyProfile = response?.data?.loyaltyProfile;
  const { tier, tierStatus } = loyaltyProfile ?? {};
  const isSweetpassPlus = tier?.name === TierName.SweetpassPlus;
  const isCancelling = tierStatus?.name === TierStatusName.CancellationPending;
  const canCancelSweetpass = isSweetpassPlus && !isCancelling;

  const formattedNextBillingDate = isValid(new Date(nextBillingDate))
    ? format(new Date(nextBillingDate), 'MM/dd/yyyy')
    : '';

  return {
    isFetchingSweetpassData,
    canCancelSweetpass,
    nextBillingDate: formattedNextBillingDate,
    subscriptionId,
  };
};
